(function(){
  var root = document.querySelector('[data-zf-core-home]');
  if(!root) return;

  document.documentElement.classList.add('zf-core-mode');

  var nav = root.querySelector('[data-zf-nav]');
  var stage = root.querySelector('[data-zf-stage]');
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function clamp(n,min,max){ return Math.max(min,Math.min(max,n)); }

  var finePointer = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  if(stage && !reduced && finePointer){
    stage.addEventListener('pointermove', function(e){
      var r = stage.getBoundingClientRect();
      var x = ((e.clientX-r.left)/r.width-.5)*2;
      var y = ((e.clientY-r.top)/r.height-.5)*2;
      root.style.setProperty('--mx', clamp(x,-1,1).toFixed(3));
      root.style.setProperty('--my', clamp(y,-1,1).toFixed(3));
    });
    stage.addEventListener('pointerleave', function(){
      root.style.setProperty('--mx','0');
      root.style.setProperty('--my','0');
    });
  }

  function onScroll(){
    var y = window.scrollY || window.pageYOffset || 0;
    if(nav) nav.classList.toggle('is-scrolled', y > 38);
    if(!reduced){
      var s = clamp(y / Math.max(window.innerHeight,1), 0, 1);
      root.style.setProperty('--sy', s.toFixed(3));
    }
  }
  onScroll();
  window.addEventListener('scroll', onScroll, {passive:true});

  var reveals = root.querySelectorAll('.zf-reveal');
  if('IntersectionObserver' in window && !reduced){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('is-inview');
          io.unobserve(entry.target);
        }
      });
    }, {threshold:.12, rootMargin:'0px 0px -40px 0px'});
    reveals.forEach(function(el,index){
      el.style.transitionDelay = Math.min(index%4,3)*70 + 'ms';
      io.observe(el);
    });
  } else {
    reveals.forEach(function(el){ el.classList.add('is-inview'); });
  }

  // Animated Core -> specialist LED routes.
  var network = root.querySelector('[data-zf-network]');
  var networkSvg = root.querySelector('[data-zf-network-svg]');
  var networkPaths = networkSvg ? networkSvg.querySelector('[data-zf-network-paths]') : null;
  var networkTargets = ['sales','crm','ops','marketing','admin'];

  function svgEl(name, attrs){
    var el = document.createElementNS('http://www.w3.org/2000/svg', name);
    Object.keys(attrs || {}).forEach(function(key){ el.setAttribute(key, attrs[key]); });
    return el;
  }

  function drawNetwork(){
    if(!network || !networkSvg || !networkPaths) return;

    var box = network.getBoundingClientRect();
    if(!box.width || !box.height) return;

    networkSvg.setAttribute('viewBox','0 0 '+box.width+' '+box.height);
    networkSvg.setAttribute('preserveAspectRatio','none');
    networkPaths.innerHTML = '';

    var core = network.querySelector('[data-zf-node="core"]');
    if(!core) return;
    var cr = core.getBoundingClientRect();
    var cx = cr.left - box.left + cr.width/2;
    var cy = cr.top - box.top + cr.height/2;

    networkTargets.forEach(function(name,index){
      var target = network.querySelector('[data-zf-node="'+name+'"]');
      if(!target) return;

      var tr = target.getBoundingClientRect();
      var tx = tr.left - box.left + tr.width/2;
      var ty = tr.top - box.top + tr.height/2;

      var dx = tx - cx;
      var dy = ty - cy;
      var bend = Math.min(Math.max(Math.abs(dx)*.24,52),120);
      var c1x = cx + (dx >= 0 ? bend : -bend);
      var c1y = cy + dy*.16;
      var c2x = tx - (dx >= 0 ? bend : -bend);
      var c2y = ty - dy*.16;
      var d = 'M '+cx.toFixed(1)+' '+cy.toFixed(1)+' C '+c1x.toFixed(1)+' '+c1y.toFixed(1)+', '+c2x.toFixed(1)+' '+c2y.toFixed(1)+', '+tx.toFixed(1)+' '+ty.toFixed(1);

      var base = svgEl('path',{
        d:d,
        class:'zf-core-network__path-base',
        'data-route':name
      });
      var led = svgEl('path',{
        d:d,
        class:'zf-core-network__path-led',
        pathLength:'100',
        'data-route':name
      });
      led.style.setProperty('--zf-led-delay',(index*.62)+'s');
      target.style.setProperty('--zf-node-delay',((index*.62)+.3)+'s');

      networkPaths.appendChild(base);
      networkPaths.appendChild(led);
    });
  }

  if(network && !reduced){
    drawNetwork();
    var resizeTimer;
    window.addEventListener('resize', function(){
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(drawNetwork,120);
    }, {passive:true});

    if('ResizeObserver' in window){
      var networkResize = new ResizeObserver(function(){ drawNetwork(); });
      networkResize.observe(network);
    }

    if('IntersectionObserver' in window){
      var networkObserver = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          network.classList.toggle('is-powered', entry.isIntersecting);
          if(entry.isIntersecting) drawNetwork();
        });
      }, {threshold:.28});
      networkObserver.observe(network);
    } else {
      network.classList.add('is-powered');
    }
  } else if(network){
    drawNetwork();
  }


  function zfStartCoreVideo(){
    var media = root.querySelector('[data-zf-core-media]');
    var videos = Array.prototype.slice.call(root.querySelectorAll('[data-zf-core-video]'));
    if(!media || videos.length < 2 || reduced) return;

    var activeIndex = 0;
    var visible = true;
    var fading = false;
    var fadeMs = 340;
    var overlapSeconds = 0.42;
    var checkTimer = null;

    videos.forEach(function(video,index){
      video.controls = false;
      video.loop = false;
      video.autoplay = index === 0;
      video.playsInline = true;
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted','');
      video.setAttribute('playsinline','');
      video.setAttribute('webkit-playsinline','');
      video.removeAttribute('controls');
      video.classList.toggle('is-active', index === 0);
    });

    function safePlay(video){
      if(!video || !visible) return;
      try{
        var p = video.play();
        if(p && typeof p.catch === 'function') p.catch(function(){});
      }catch(e){}
    }

    function swapLoop(){
      if(fading || !visible) return;
      var current = videos[activeIndex];
      var duration = current.duration;
      if(!isFinite(duration) || duration <= overlapSeconds) return;
      if(current.currentTime < duration - overlapSeconds) return;

      fading = true;
      var nextIndex = activeIndex === 0 ? 1 : 0;
      var next = videos[nextIndex];
      try{ next.currentTime = 0; }catch(e){}
      safePlay(next);
      next.classList.add('is-active');

      window.setTimeout(function(){
        current.classList.remove('is-active');
        try{
          current.pause();
          current.currentTime = 0;
        }catch(e){}
        activeIndex = nextIndex;
        fading = false;
      }, fadeMs);
    }

    function beginChecks(){
      if(checkTimer) return;
      checkTimer = window.setInterval(swapLoop, 90);
    }

    function stopChecks(){
      if(checkTimer){
        window.clearInterval(checkTimer);
        checkTimer = null;
      }
    }

    videos.forEach(function(video){
      video.addEventListener('canplay', function(){
        if(video === videos[activeIndex]) safePlay(video);
      }, {passive:true});
      video.addEventListener('ended', function(){
        if(video !== videos[activeIndex] || fading) return;
        try{ video.currentTime = 0; }catch(e){}
        safePlay(video);
      }, {passive:true});
    });

    if('IntersectionObserver' in window){
      var mediaObserver = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          visible = entry.isIntersecting && entry.intersectionRatio > .05;
          if(visible){
            safePlay(videos[activeIndex]);
            beginChecks();
          }else{
            videos.forEach(function(video){ try{ video.pause(); }catch(e){} });
            stopChecks();
          }
        });
      }, {threshold:[0,.05,.2]});
      mediaObserver.observe(media);
    }else{
      beginChecks();
    }

    document.addEventListener('visibilitychange', function(){
      if(document.hidden){
        videos.forEach(function(video){ try{ video.pause(); }catch(e){} });
        stopChecks();
      }else if(visible){
        safePlay(videos[activeIndex]);
        beginChecks();
      }
    }, {passive:true});

    window.addEventListener('pageshow', function(){
      if(visible){
        safePlay(videos[activeIndex]);
        beginChecks();
      }
    }, {passive:true});

    safePlay(videos[0]);
    beginChecks();
  }

  zfStartCoreVideo();

})();